import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLightbulb32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLightbulb32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.999 17.199a2 2 0 0 0-.999 1.73V22h-4v-3.07a2 2 0 0 0-.998-1.732A6.01 6.01 0 0 1 10 12a6 6 0 1 1 8.999 5.198M12 22v-3.07A7.99 7.99 0 0 1 8 12a8 8 0 1 1 12 6.93V22a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2m1.5 4a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLightbulb32);
